import React, { useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';

export default function useIsMobile() {
  const { passedAppFunctions } = useContext(AppContext);

  return passedAppFunctions.siteFormat === 'mobile';
}
